import { EBaseCommonEntrance } from '@core/main/types';

/**
 * 常用入口信息
 */
export interface ICommonEntry {
  /** 常用入口ID */
  id: number;
  /** 业务线ID */
  businessId: number;
  /** 常用入口枚举值 */
  dataKey: EBaseCommonEntrance;
  /** 常用入口菜单名称 */
  name: string;
  /** 菜单路由名称 */
  routeName: string;
  /** 图片URL */
  imgSrc: string;
}

/**
 * 常用入口列表响应
 */
export interface ICommonEntryResponse {
  /** 已添加常用入口列表 */
  addedEntries: ICommonEntry[];
  /** 可添加常用入口列表 */
  availableEntries: ICommonEntry[];
}

/**
 * 轮播图列表响应
 */
export interface ICarouselListResponse {
  /** id */
  id: number;
  /** 轮播图图片URL */
  imageUrl: string;
  /** 轮播图展示顺序 */
  sort: string;
}

/**
 * 轮播图修改请求
 */
export interface ICarouselUpdateRequest {
  /** id */
  id: number;
  /** 轮播图图片URL */
  imageUrl: string;
}

/**
 * 首页 - 统计数据列表
 */
export interface IStatisticsResponse {
  /** 业务线id集合 */
  businessIds: number[];
  /** 智慧分账统计数据 */
  splitList: IStatisticsItem[];
  /** 众包灵工统计数据 */
  crowdList: IStatisticsItem[];
  /** 撮合灵工统计数据 */
  matchList: IStatisticsItem[];
  /** 基础管理统计数据 */
  systemList: IStatisticsItem[];
}

/**
 * 统计数据项
 */
export interface IStatisticsItem {
  /** 字段名称 */
  name: string;
  /** 字段值 */
  value: number;
}

/**
 * 首页 - 管理 - 统计数据列表
 */
export interface IDataStatisticsManage {
  /** 已添加统计数据列表 */
  addedStatistics: IDataStatisticsItem[];
  /** 可添加统计数据列表 */
  availableStatistics: IDataStatisticsItem[];
}

/**
 * 首页 - 统计数据列表
 */
export interface IDataStatisticsItem {
  /** 统计数据ID */
  id: number;
  /** 统计数据名称 */
  name: string;
  /** 统计数据类型 */
  dataKey: string;
}

/**
 * 首页 - 统计数据配置请求
 */
export interface IStatisticsConfigRequest {
  /** 业务ID */
  businessId: number;
  /** 统计数据ID列表 */
  ids: number[];
}

export const homePageCosUrl = 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/lg5-homepage/entry/';

/**
 * 首页 - 代理商分润总额排名
 */
export interface IStatisticsRankRes {
  /** 代理商名称 */
  agentName: string;
  /** 分润总额 */
  totalRevenue: number;
  /** 排名Url */
  rankUrl: string;
}

/**
 * 首页 - 代理商预估收益
 */
export interface IAgentEstimateRes {
  /** 总收益 */
  totalRevenue: number;
  /** 保线内金额（推广服务费） */
  inLineAmount: number;
  /** 保线外金额（溢价服务费） */
  outLineAmount: number;
  /** 结算周期 */
  date: string;
}

/**
 * 首页 - 柱状图统计
 */
export interface IAgentTrendRes {
  /** 推广服务费 */
  inLineAmount: number[];
  /** 溢价服务费 */
  outLineAmount: number[];
  /** 总收益 */
  totalRevenue: number[];
  /** 月份 */
  monthDate: string[];
}